
import * as Actions from '../../actions/app'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'

const initialState = {
  store_locations: [],
  loading_store_locations: false,
  saving_store_location: false,
  saved_store_location: false,
  deleting_store_location: false,
}

const storeLocationsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_STORE_LOCATION: {
      return {
        ...state,
        saving_store_location: action.payload.saving,
        saved_store_location: action.payload.saved,
        store_locations: action.payload.data
          ? addOrUpdateObjectInArray(state.store_locations, action.payload.data, 'ubicacion_almacen_id')
          : state.store_locations
      }
    }

    case Actions.DELETE_STORE_LOCATION: {
      return {
        ...state,
        deleting_store_location: action.payload.deleting,
        store_locations: action.payload.deleted
          ? state.store_locations.filter(item => item.ubicacion_almacen_id !== action.payload.id)
          : state.store_locations
      }
    }

    default: {
      return state
    }
  }
}

export default storeLocationsReducer
